import Image from 'next/image'
import type { FC } from 'react'
import type { ImageData } from '../../frontend-types'
import { ImageWithCorner } from '../atoms/ImageWithCorner'

export type ImageGridProps = {
	images: ImageData[]
}

export const ImageGrid: FC<ImageGridProps> = ({ images }) => {
	if (!images || images.length === 0) {
		return null
	}

	return (
		<div className="grid grid-cols-2 gap-xl tablet-l:grid-cols-2">
			<div className="col-span-2">
				<ImageWithCorner
					key={images[0].src}
					image={images[0]}
					sizes="(max-width: 767px) 100vw, (max-width: 1023px) 75vw, (max-width: 1559px) 50vw, 656px"
				/>
			</div>

			{images.slice(1).map((image) => (
				<div className="col-span-1" key={image.src}>
					<div className="relative aspect-video w-full overflow-hidden rounded-sm">
						<Image
							src={image.src}
							alt={image.alt}
							fill
							className="object-cover"
							sizes="(max-width: 767px) 50vw, (max-width: 1023px) 25vw, (max-width: 1559px) 25vw, 316px"
						/>
					</div>
				</div>
			))}
		</div>
	)
}
